export default {
	"AtInteceptModal.YouHaveNotSavedYourShippingAddressInformationPleaseSaveItAndThenLeaveSoThatTheSystemCanHelpYouArrangeTheShipmentAsSoonAsPossible": "You have not saved your shipping address information, please save it and then leave so that the system can help you arrange the shipment as soon as possible",
	"AtInteceptModal.return": "return"
}